// extracted by mini-css-extract-plugin
module.exports = {"noreviewsCount":"ProviderReviewSummary_noreviewsCount__p1m7R","noReviews":"ProviderReviewSummary_noReviews__THMih","reviewTextColor":"ProviderReviewSummary_reviewTextColor__dp8Zx"};